<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/storage/topic_icon.svg" />
      <h1>Warehouse Facilities</h1>
      <p>
        We provide continuous and flawless management of warehouse facilities that
        <br />
        store various types of goods.
      </p>
      <div class="topic-tags">
        <span class="tag"> #Logistics Warehouses </span>
        <span class="tag"> #Delivery Logistics Centers </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img
      :src="require(`@/assets/images/location/storage/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [BusinessSectors] Warehouse Facilities"
    />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_pests.svg" alt="CESCO [BusinessSectors] Warehouse Facilities" />
            <div class="title">
              <h3>24-Hour Reliable Pest Control</h3>
            </div>
            <p class="description">I am worried about significant damage from pests and mice during storage and shipping.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_virus.svg" alt="CESCO [BusinessSectors] Warehouse Facilities" />
            <div class="title">
              <h3>Professional Virus Management</h3>
            </div>
            <p class="description">As the manufacturing process occurs in enclosed spaces, the spread of viral infections is a concern.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_check.svg" alt="CESCO [BusinessSectors] Warehouse Facilities" />
            <div class="title">
              <h3>Quality Management of Logistics Goods</h3>
            </div>
            <p class="description">
              I want to prevent any claims related to foreign objects and pests that might arise during the distribution process.
            </p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>
              Safeguard your valuable business assets with a pest control system monitored 24 hours a day.
              <br />
            </h4>
            <p>
              Given their geographic characteristics and round-the-clock accessibility, various warehouses require crucial pest control measures.
              CESCO provides comprehensive solutions that effectively block pest entry at the outermost warehouse perimeters, around building
              exteriors, and inside interiors.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/storage/border_content_01.png" alt="CESCO [BusinessSectors] Warehouse Facilities" />
          </div>
          <div>
            <img src="@/assets/images/location/storage/border_content_02.png" alt="CESCO [BusinessSectors] Warehouse Facilities" />
          </div>
          <div class="border-content">
            <h4>Tailor-made virus care solutions for specific spaces and work environments.</h4>
            <p>
              Warehouses, where diverse personnel handle goods, are at increased risk of virus transmission if exposed. CESCO facilitates 24-hour
              monitoring with devices optimized for each area and ensures safety through the sterilization of distribution vehicles.
            </p>
          </div>
          <div class="border-content">
            <h4>Ensure the health and hygiene of your employees through CESCO’s systematic management.</h4>
            <p>
              With rising distribution volumes of appliances and food, the risk of foreign matter contamination also increases. CESCO can precisely
              diagnose foreign matter after contamination incidents and offer strategies for prevention and resolution.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/storage/border_content_03.png" alt="CESCO [BusinessSectors] Warehouse Facilities" />
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="CESCO [BusinessSectors] Warehouse Facilities" />

          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="CESCO [BusinessSectors] Warehouse Facilities" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Warehouse Facilities
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="CESCO [BusinessSectors] Warehouse Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_fly.svg" alt="CESCO [BusinessSectors] Warehouse Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>Flying Pest Control Solution</h3>
              </div>
              <p class="description">Managing stray pests such as flies, fruit flies, and sandflies</p>
            </div>

            <router-link to="/solution/service/fly"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="CESCO [BusinessSectors] Warehouse Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/storage/background_img_01.png'),
    products: [
      {
        posX: '46rem',
        posY: '30.0625rem',
        mobilePosX: '61%',
        mobilePosY: '80%',
        productInfo: {
          image: require('@/assets/images/location/storage/product_img_01.png'),
          name: 'CESCO\nSmart Indoor Rodent Control Equipment Viper',
          description: 'Hygienically captures rats that enter business premises and monitors their movement and habitation with smart technology.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/storage/background_img_02.png'),
    products: [
      {
        posX: '22.6875rem',
        posY: '22.625rem',
        mobilePosX: '28%',
        mobilePosY: '61%',
        productInfo: {
          image: require('@/assets/images/location/storage/product_img_02.png'),
          name: 'CESCO Thunderblue',
          description: 'This system prevents the intrusion of stray pests from outside with its automatic counting and robust capturing capabilities.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/storage/background_img_03.png'),
    products: [
      {
        posX: '57.625rem',
        posY: '12.875rem',
        mobilePosX: '76%',
        mobilePosY: '37%',
        productInfo: {
          image: require('@/assets/images/location/storage/product_img_03.png'),
          name: 'CESCO\nIndoor Insect Light Phoenix',
          description: 'Effectively attracts and captures stray pests within business premises.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/storage/background_img_04.png'),
    products: [
      {
        posX: '56.1875rem',
        posY: '15.375rem',
        mobilePosX: '74%',
        mobilePosY: '40%',
        productInfo: {
          image: require('@/assets/images/location/storage/product_img_04.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/storage/background_img_05.png'),
    products: [
      {
        posX: '20.75rem',
        posY: '16.625rem',
        mobilePosX: '25%',
        mobilePosY: '46%',
        productInfo: {
          image: require('@/assets/images/location/storage/product_img_05.png'),
          name: 'CESCO Thunderblue',
          description: 'This system prevents the intrusion of stray pests from outside with its automatic counting and robust capturing capabilities.'
        }
      }
    ]
  },

  {
    backgroundImg: require('@/assets/images/location/storage/background_img_06.png'),
    products: [
      {
        posX: '15.5rem',
        posY: '13.625rem',
        mobilePosX: '23%',
        mobilePosY: '37%',
        productInfo: {
          image: require('@/assets/images/location/storage/product_img_06.png'),
          name: 'CESCO\nBluestorm',
          description: 'With its customizable structure, it can be installed flexibly to block stray pests from entering from outside.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}

useMeta({
  title: 'CESCO - Warehouse Facilities',
  meta: [
    {
      name: 'description',
      content: 'Warehouse Facilities. We provide continuous and flawless management of warehouse facilities that store various types of goods.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
